// src/utils/api.js
import { useMemo } from "react";

const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  return envUrl || "/api";
};

export const useApi = () => {
  const API_BASE_URL = useMemo(() => getBaseUrl(), []);

  const http = useMemo(() => {
    const handle = async (path, options = {}) => {
      const url = `${API_BASE_URL}${path}`;

      const res = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          ...(options.headers || {}),
        },
        ...options,
      });

      const ct = res.headers.get("content-type") || "";
      const isJson = ct.includes("application/json");
      const data = isJson ? await res.json() : null;

      if (!res.ok && res.status !== 204) {
        const err = new Error(
          data?.detail || data?.message || res.statusText || "İstek başarısız"
        );
        err.status = res.status;
        err.data = data;
        throw err;
      }

      return data;
    };

    return {
      get: (p, params) => {
        const q = params ? `?${new URLSearchParams(params).toString()}` : "";
        return handle(p + q, { method: "GET" });
      },
      post: (p, body) =>
        handle(p, { method: "POST", body: JSON.stringify(body) }),
      put: (p, body) =>
        handle(p, { method: "PUT", body: JSON.stringify(body) }),
      del: (p) => handle(p, { method: "DELETE" }),

      // Form-data upload
      postForm: async (p, formData) => {
        const res = await fetch(`${API_BASE_URL}${p}`, {
          method: "POST",
          body: formData,
        });

        const ct = res.headers.get("content-type") || "";
        const isJson = ct.includes("application/json");
        const data = isJson ? await res.json() : null;

        if (!res.ok && res.status !== 204) {
          const err = new Error(
            data?.detail || res.statusText || "Yükleme başarısız"
          );
          err.status = res.status;
          err.data = data;
          throw err;
        }

        return data;
      },

      // Dosya indirme
      getBlob: async (p) => {
        const res = await fetch(`${API_BASE_URL}${p}`);
        if (!res.ok) throw new Error("Dosya indirilemedi");
        return res.blob();
      },
    };
  }, [API_BASE_URL]);

  return http;
};